module.exports = __webpack_public_path__ + "media/images/admin/auth-bg-a0a0144a3b940ad052c2449ea6683203.jpg";